export const updateVariationUrl = () => {
  const updateURL = (variation) => {
      if (variation && variation.variation_id && variation.attributes) {
        const url = new URL(window.location.href);
        for (const [attribute, value] of Object.entries(variation.attributes)) {
          url.searchParams.set(attribute, value);
        }
        window.history.replaceState({}, '', url.toString());
      }
  };

  jQuery(document).ready(function($) {
    $('form.variations_form').on('found_variation', function (event, variation) {
      updateURL(variation);
    });
  });
};
